import { Component, OnInit, Input } from "@angular/core";
import { TokenStorageService } from "src/app/core/service/token-storage.service";

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.sass"],
})
export class BreadcrumbComponent implements OnInit {
  @Input() title: string;
  @Input() items: any[];
  @Input() active_item: string;
  homeRoute: string = '/admin/dashboard/main';

  constructor(private tokenStorage: TokenStorageService) {}

  ngOnInit()  {
    console.log('Breadcrumb Component Loaded', this.title, this.items, this.active_item);
    this.setHomeRoute();
  }

  private setHomeRoute(): void {
    const user = this.tokenStorage.getUser();
    if (user && user.permissions) {
      const userModules = Object.keys(user.permissions);
      const hasChurchAdminAccess = userModules.includes("CHURCH_DASHBOARD");
      const hasBankHQAccess = userModules.includes("OVERALL_DASHBOARD");
      const hasRelationshipManagerAccess = (userModules.includes("CHURCH") || userModules.includes("CHURCH_PROFILE")) && !hasChurchAdminAccess && !hasBankHQAccess;
      
      if (hasChurchAdminAccess) {
        this.homeRoute = '/admin/dashboard';
      } else if (hasBankHQAccess) {
        this.homeRoute = '/bank-officer/bank-dashboard';
      } else if (hasRelationshipManagerAccess) {
        this.homeRoute = '/bank-officer/rm-dashboard';
      }
    }
  }
}
